// extracted by mini-css-extract-plugin
export default {"wrapper":"toolbar_wrapper__dVwKS","questionwrapper":"toolbar_questionwrapper__6hw9+","item":"toolbar_item__2D0Wo","label":"toolbar_label__g0QYb"};